export const BackButtonStyle = {
  backgroundColor: 'white',
  borderWidth: 1,
  borderColor: 'rgb(108 108 108)',
  borderStyle: 'solid',
  color: 'rgb(108 108 108)'
}